import { Close as CloseIcon, Menu as MenuIcon } from '@mui/icons-material';
import commonMessages from '@rhg/lang/messages/common';
import { Drawer, IconButton, Toolbar, Box, Theme } from '@rhg/libs/material';
import { ReactNode } from 'react';
import { useIntl } from 'react-intl';
import AppLogo from '../app-logo';

const styleDrawer = {
    display: { xs: 'block', sm: 'block', md: 'flex', lg: 'none' },
};
const stylePaper = {
    boxSizing: 'border-box',
    width: '100%',
};
const styleMenuButton = {
    display: { xs: 'flex', sm: 'flex', md: 'flex', lg: 'none' },
};
const styleToolbar = {
    mb: (theme: Theme) => theme.ds.spacingUnits.CONTENT,
};
const styleContent = {
    display: 'flex',
    flexDirection: 'column',
    px: (theme: Theme) => ({
        sm: theme.ds.spacingUnits.SIDE_SMALL,
        md: theme.ds.spacingUnits.SIDE_MEDIUM,
        lg: theme.ds.spacingUnits.SIDE_LARGE,
    }),
};

interface MobileMainMenuProps {
    isOpen: boolean;
    handleToggle: () => void;
    children: ReactNode | ReactNode[];
}
export const MobileMainMenu = ({
    isOpen,
    handleToggle,
    children,
}: MobileMainMenuProps) => {
    const { formatMessage } = useIntl();

    return (
        <>
            <IconButton
                size="medium"
                aria-label={formatMessage(
                    commonMessages['common.open_main_menu']
                )}
                aria-expanded={isOpen}
                aria-haspopup="true"
                onClick={handleToggle}
                color="primary"
                trackButton="MobileMenu"
                sx={styleMenuButton}
            >
                <MenuIcon />
            </IconButton>
            <Drawer
                data-testid="MOBILE_DRAWER"
                variant="temporary"
                ModalProps={{
                    keepMounted: true, // Better open performance on mobile.
                }}
                sx={styleDrawer}
                PaperProps={{ sx: stylePaper }}
                open={isOpen}
                onClose={handleToggle}
                role="navigation"
            >
                <Toolbar sx={styleToolbar}>
                    <AppLogo onClick={handleToggle} />
                    <IconButton
                        size="medium"
                        aria-label={formatMessage(
                            commonMessages['common.close_main_menu']
                        )}
                        onClick={handleToggle}
                        color="primary"
                        trackButton="MobileMenuClose"
                        sx={styleMenuButton}
                    >
                        <CloseIcon />
                    </IconButton>
                </Toolbar>
                <Box sx={styleContent}>{children}</Box>
            </Drawer>
        </>
    );
};

export default MobileMainMenu;
